import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../img/bg_clear.jpg';
import { theme, Flex, Button, Typography, Avatar, Row, Col, Card } from 'antd';
import { LockTwoTone, DollarTwoTone, LaptopOutlined } from '@ant-design/icons';
import { motion } from "framer-motion";
const { Title, Text } = Typography;

const Home = () => {

  const {
    token: { colorPrimary },
  } = theme.useToken();
  const navigate = useNavigate();
  const { userToken } = useSelector((state) => state.auth)
  return (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.3 }}
      >
      <div className='site-page'>
        <Card
          className='home-hero-card'
          bordered={false}
          style={{ backgroundImage: `linear-gradient(135deg, rgba(15,23,42,0.78), rgba(15,118,110,0.52)), url(${backgroundImage})`, backgroundSize: 'cover' }}
        >
          <Flex vertical justify='center' align='center' className='home-hero-content'>
            <Text className='home-hero-eyebrow'>Getman 1</Text>
            <Title level={1} className='home-hero-title'>Керування доступом і оплатами без зайвих кроків</Title>
            <Text className='home-hero-text'>
              Особистий кабінет для мешканців і користувачів паркінгу. Баланс, рахунки, історія платежів і доступ до сервісів в одному місці.
            </Text>
            <Flex gap={12} wrap='wrap' justify='center'>
              <Button onClick={() => userToken === null ? navigate('/sign-in') : navigate('/profile')} className='home-primary-cta' shape='round' size='large' type="primary">
                РОЗПОЧАТИ
              </Button>
              <Button onClick={() => navigate('/about')} shape='round' size='large'>
                ДЕТАЛІ
              </Button>
            </Flex>
            <div className='home-hero-note'>
              Оплата послуги здійснюється щомісяця в розмірі 50 грн за 1 акаунт.
            </div>
          </Flex>
        </Card>
      </div>
      <Flex className='site-section-title' vertical justify='center' align='center'>
        <Title level={2} style={{ marginTop: 0, marginBottom: 0 }}>ПЕРЕВАГИ</Title>
      </Flex>
      <Row className='home-benefits-row' justify='center' align='stretch'>
        <Col xs={24} sm={12} lg={8} xl={8} xxl={8}>
          <Card className='home-benefit-card' bordered={false}>
          <Flex flex={1} gap='middle' vertical justify='center' align='center'>
            <Avatar style={{ backgroundColor: 'white' }} shape="circle" size={64} icon={<LockTwoTone twoToneColor={colorPrimary} />} />
            <Title level={4} style={{ marginTop: 10, marginBottom: 0 }}>Безпека</Title>
            <Text className='home-benefit-text'>Ваші дані та керування доступом зібрані в одному захищеному кабінеті.</Text>
          </Flex>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8} xl={8} xxl={8}>
          <Card className='home-benefit-card' bordered={false}>
          <Flex flex={1} gap='middle' vertical justify='center' align='center'>
            <Avatar style={{ backgroundColor: 'white' }} shape="circle" size={64} icon={<DollarTwoTone twoToneColor={colorPrimary} />} />
            <Title level={4} style={{ marginTop: 10, marginBottom: 0 }}>Стан балансу</Title>
            <Text className='home-benefit-text'>Переглядайте баланс, рахунки та поповнення без дзвінків і ручних уточнень.</Text>
          </Flex>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8} xl={8} xxl={8}>
          <Card className='home-benefit-card' bordered={false}>
          <Flex flex={1} gap='middle' vertical justify='center' align='center'>
            <Avatar style={{ backgroundColor: 'white' }} shape="circle" size={64} icon={<LaptopOutlined style={{ color: colorPrimary }} />} />
            <Title level={4} style={{ marginTop: 10, marginBottom: 0 }}>На всіх пристоях</Title>
            <Text className='home-benefit-text'>Інтерфейс адаптований для смартфона, планшета та desktop без окремого застосунку.</Text>
          </Flex>
          </Card>
        </Col>
      </Row>
    </motion.div>
  );
};
export default Home;
